const envs = {
  PORT: process.env.PORT,
  PUBLIC_URL: process.env.PUBLIC_URL,
  API_URL: process.env.REACT_APP_API_URL,
  BASENAME: process.env.REACT_APP_BASENAME,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
};

export default envs;
